import {Directive, ContentChild} from '@angular/core';
import {TableColumnLabelDirective} from "./table-column-label.directive";
import {TableColumnContentDirective} from "./table-column-content.directive";
import {Input} from "@angular/core";

@Directive({
  selector: 'table-column'
})
export class TableColumnDirective {

  @ContentChild(TableColumnLabelDirective) label: TableColumnLabelDirective;
  @ContentChild(TableColumnContentDirective) content: TableColumnLabelDirective;

  @Input("label") labelText: string = null;

  constructor() { }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/data-table/table-column.directive.ts